import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../../hooks/useTranslations";
import { useRoofTypesApi } from "../../../../../../http/patrol/useRoofTypes";
import FlexContent from "../../../../../ui/FlexContent";
import Header from "../../../../../ui/Header";
import { PATROL } from "../../../AdminSystemSettings";
import RoofTypeDetails from "./RoofTypeDetails";

const RoofType: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { categoryId } = useParams<{ categoryId: string }>();
  const { roofTypeId } = useParams<{ roofTypeId: string }>();
  const roofTypesApi = useRoofTypesApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = roofTypesApi.getAdminRoofType(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=0`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.roofCategories.plural}`,
    },
    {
      url: `/admin/systems/${systemId}/roof_categories/${categoryId}?tab=1`,
      display: `${i18n.translation.roofTypes.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    roofTypeId && trigger(roofTypeId);
  }, [roofTypeId]);

  return (
    <>
      <Header title={`${i18n.translation.roofTypes.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <RoofTypeDetails roofType={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default RoofType;
